<template lang="pug">
	div
		.sfc-container-redesign-v1
			sfc-sentry
			sfc-hello-bar-v3
			sfc-gtm-body
			sfc-dfp
			sfc-heap
			sfc-login
			sfc-forgot-password
			sfc-enroll-now-urgency-widget(:inPage="false")
			sfc-menu
			sfc-menu-mobile
			sfc-onboarding-modal-v2
			sfc-header
			#sfc-main-content-new
				nuxt
			no-ssr(v-if="!userSubscribed()")
				b-row#bottom-ad
					.col-md-12.col-sm-12.col-xs-12.ad-align-center
						.bottom-banner(style="")
							sfc-dfp-ad(ad-unit="savingforcollege_other_bottom_leaderboard" sizes="[[600,230], [728,90]]")
			sfc-footer
			no-ssr
				sfc-gdpr-banner
			no-ssr
				sfc-modal-trigger
			no-ssr
				enroll-now-modal
		no-ssr
			sfc-college-savings-questions-modal
		no-ssr
			sfc-mobile-conversion-bar-ad
</template>

<style lang="stylus" scoped>
	#bottom-ad
		background: #f8f8f8
		.bottom-banner
			text-align: center
			padding: 24px 0
			@media (max-width: 767px)
				padding: 16px 0
</style>

<script>
import SfcHeader from '@/layouts/common/redesign-v1/sfc-header'
import SfcFooter from '@/layouts/common/redesign-v1/sfc-footer'
import SfcModalTrigger from '@/common/components/modals/modal-trigger'
import EnrollNowModal from '@/common/components/modals/enroll-now-modal'
import sfcCollegeSavingsQuestionsModal from '@/common/components/path/sfc-college-savings-questions-modal'
import SfcHelloBarV3 from '@/common/components/hello-bar/sfc-hello-bar-v3'
import SfcMenu from '@/layouts/common/redesign-v1/sfc-menu-v2'
import SfcMenuMobile from '@/layouts/common/redesign-v1/sfc-menu-mobile-v2'
import SfcEnrollNowUrgencyWidget from '@/common/components/redesign-v1/sfc-enroll-now-urgency-widget'
import SfcLogin from '@/common/components/sfc-login-modal'
import SfcForgotPassword from '@/common/components/sfc-forgot-password-modal'
import SfcOnboardingModalV2 from '@/common/components/savings-center/v3/onboarding/modal-v2'
import SfcMobileConversionBarAd from '@/common/components/sfc-mobile-conversion-bar-ad'

export default {
	components: {
		SfcHeader,
		SfcFooter,
		SfcModalTrigger,
		EnrollNowModal,
		sfcCollegeSavingsQuestionsModal,
		SfcHelloBarV3,
		SfcMenu,
		SfcMenuMobile,
		SfcEnrollNowUrgencyWidget,
		SfcLogin,
		SfcForgotPassword,
		SfcOnboardingModalV2,
		SfcMobileConversionBarAd
	},
	methods: {
		userSubscribed(){
			return (this.$store.state.sfcSubscriptions && this.$store.state.sfcSubscriptions.subscription_order_id)
		}
	}
}
</script>
